"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalBaseTheme = function (_a) {
    var _b, _c;
    var MEDIA_PRINT = _a.MEDIA_PRINT, MAX_L = _a.MAX_L, MAX_S = _a.MAX_S, MAX_M = _a.MAX_M, MIN_M = _a.MIN_M, MAX_XL = _a.MAX_XL, cssPrefix = _a.cssPrefix;
    return ({
        '@global': (_b = {
                "html, body, #__next": {
                    overflow: "hidden",
                    height: "100%",
                    width: "100%",
                    "-webkit-font-smoothing": "antialiased"
                },
                "*, *::before, *::after": {
                    boxSizing: "border-box"
                },
                ".b": {
                    "font-weight": "bold"
                },
                ".disabled-link": {
                    pointerEvents: "none"
                }
            },
            _b[".index-root ." + cssPrefix + "_hero_title-wrapper ." + cssPrefix + "_nav-popover_title"] = {
                display: "none"
            },
            _b[".search-index ." + cssPrefix + "_hero_title"] = {
                display: "none"
            },
            _b["render-html"] = {
                display: "block"
            },
            _b["i18n-message"] = {
                display: "inline-block"
            },
            _b["i18n-message > p"] = {
                fontFamily: "inherit",
            },
            _b["input:-webkit-autofill"] = {
                "-webkit-box-shadow": "0 0 0 30px #FFFFFF inset",
            },
            _b[".mui-tree-item_root.mui-tree-item_selected:focus > .mui-tree-item_content .mui-tree-item_label"] = {
                backgroundColor: 'inherit !important',
            },
            _b[".mui-tree-item_root.mui-tree-item_selected > .mui-tree-item_content .mui-tree-item_label"] = {
                backgroundColor: 'inherit !important',
            },
            _b[".fn > p"] = {
                display: "inline"
            },
            _b[".title.topictitle1"] = {
                marginTop: "0"
            },
            _b[".no-alt"] = {
                textIndent: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden"
            },
            _b[".content-main"] = {
                flex: 1,
            },
            _b[".content-main table"] = {
                textAlign: "left",
                borderCollapse: "collapse",
                borderSpacing: "5px",
                display: "block",
                overflowX: "auto",
                "& thead > tr > th:last-child": {
                    whiteSpace: "nowrap",
                    overflowX: "visible"
                },
            },
            _b[".content-main tr, td, th"] = {
                padding: "0.5rem"
            },
            _b[".content-main img"] = {
                maxWidth: "100%"
            },
            _b[".content-main ol"] = {
                overflowX: "auto"
            },
            _b[".content-main ul"] = {
                overflowX: "auto"
            },
            _b[".content-main .prettyprint"] = {
                overflowX: "auto"
            },
            _b[".image"] = {
                maxWidth: "100%"
            },
            _b[MAX_XL] = {
                ".content-main .title.topictitle1": {
                    fontSize: "1.5rem"
                }
            },
            _b[MAX_L] = {
                ".content-main iframe": {
                    width: "100% !important"
                },
                ".content-main main > article > h1:nth-child(1)": {
                    marginRight: "5rem"
                },
            },
            _b[MAX_M] = {
                ".content-main img": {
                    height: 'auto',
                    maxWidth: '100%'
                },
                ".content-main object": {
                    width: "100% !important",
                    objectFit: "contain",
                    paddingBottom: "20%",
                    marginBottom: "-20%"
                },
                ".content-main table": {
                    maxWidth: "calc(100vw - 3rem)"
                },
                ".content-main ol": {
                    maxWidth: "calc(100vw - 3rem)"
                },
                ".content-main ul": {
                    maxWidth: "calc(100vw - 3rem)"
                },
                ".content-main .prettyprint": {
                    maxWidth: "calc(100vw - 3rem)"
                },
            },
            _b[MIN_M] = {
                ".content-main table": {
                    maxWidth: "calc(75vw - 11rem)"
                },
                ".content-main ol": {
                    maxWidth: "calc(52vw - 1rem)"
                },
                ".content-main ul": {
                    maxWidth: "calc(52vw - 1rem)"
                },
                ".content-main .prettyprint": {
                    maxWidth: "calc(52vw - 1rem)"
                },
            },
            _b[MAX_S] = {
                ".content-main main > article > h1:nth-child(1)": {
                    marginRight: "2.5rem"
                }
            },
            _b[MEDIA_PRINT] = {
                "#__next": {
                    height: "auto !important",
                    display: "block !important",
                    "-webkit-print-color-adjust": "exact !important"
                },
                body: {
                    height: "auto !important",
                    display: "block !important",
                    "-webkit-print-color-adjust": "exact !important"
                },
                html: {
                    height: "auto !important",
                    display: "block !important",
                },
                "table, li, tr, .video_wrapper": {
                    breakInside: "avoid-page",
                    pageBreakInside: "avoid"
                },
                ".video-wrapper": {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                },
                ".ondemand_video.material-icons": {
                    border: "1px solid gray",
                    height: "5rem",
                    padding: "6rem 5rem",
                    display: "flex",
                    alignItems: "center",
                    width: "50%",
                    fontSize: "5rem",
                    justifyContent: "center",
                    margin: "1rem auto",
                },
                ".video-link": {
                    display: "block"
                }
            },
            _b["." + cssPrefix + "_hero_nav-popover"] = (_c = {
                    padding: "1rem"
                },
                _c["& ." + cssPrefix + "_nav-popover_home-href"] = {
                    flexBasis: "100%",
                },
                _c),
            _b[".react-checkbox-tree"] = {
                display: "flex",
                WebkitBoxOrient: "horizontal",
                fontSize: "16px",
                width: "100%"
            },
            _b[".react-checkbox-tree label"] = {
                display: "flex",
                alignItems: "center",
                marginBottom: "0",
                cursor: "pointer"
            },
            _b[".rct-checkbox"] = { display: "flex" },
            _b[".rct-text"] = {
                display: "flex",
                WebkitBoxAlign: "center",
                msFlexAlign: "center",
                alignItems: "center"
            },
            _b[".rct-collapse, .rct-checkbox, .rct-node-icon"] = { padding: "initial" },
            _b[".react-checkbox-tree > ol"] = {
                WebkitBoxFlex: "1",
                msFlex: "1 1 auto",
                flex: "1 1 auto"
            },
            _b[".react-checkbox-tree ol"] = {
                margin: "0",
                paddingLeft: "0",
                listStyleType: "none"
            },
            _b[".react-checkbox-tree ol ol"] = { paddingLeft: "1.125rem" },
            _b[".react-checkbox-tree button"] = { lineHeight: "normal", color: "inherit" },
            _b[".react-checkbox-tree button:focus"] = { outline: "none" },
            _b[".react-checkbox-tree button:disabled"] = { cursor: "not-allowed" },
            _b[".react-checkbox-tree .rct-bare-label"] = { cursor: "default" },
            _b[".react-checkbox-tree label:hover"] = {
                backgroundcolor: "rgba(51, 51, 204, 0.1)"
            },
            _b[".react-checkbox-tree label:active"] = {
                backgroundcolor: "rgba(51, 51, 204, 0.15)"
            },
            _b[".react-checkbox-tree:not(.rct-native-display) input"] = { display: "none" },
            _b[".react-checkbox-tree.rct-native-display input"] = { margin: "0 5px" },
            _b[".react-checkbox-tree .rct-icon"] = { fontStyle: "normal" },
            _b[".rct-disabled > .rct-text > label"] = { opacity: 0.75, cursor: "not-allowed" },
            _b[".rct-disabled > .rct-text > label:hover"] = { backgroundcolor: "transparent" },
            _b[".rct-disabled > .rct-text > label:active"] = {
                backgroundcolor: "transparent"
            },
            _b[".rct-options"] = {
                WebkitBoxFlex: "0",
                msFlex: "0 0 auto",
                flex: "0 0 auto",
                marginLeft: ".5rem",
                textAlign: "right"
            },
            _b[".rct-option"] = {
                opacity: 0.75,
                border: "0",
                background: "none",
                cursor: "pointer",
                padding: "0 4px",
                fontSize: "1.125rem"
            },
            _b[".rct-option:hover"] = { opacity: 1 },
            _b[".rct-option + .rct-option"] = { marginLeft: "2px" },
            _b[".rct-collapse *, .rct-checkbox *, .rct-node-icon *"] = {
                display: "inline-block",
                margin: "0",
                width: "1rem"
            },
            _b[".rct-collapse"] = {
                border: "0",
                background: "none",
                lineHeight: "normal",
                color: "inherit",
                fontSize: "12px"
            },
            _b[".rct-collapse.rct-collapse-btn"] = { cursor: "pointer" },
            _b[".rct-collapse > .rct-icon-expand-close"] = { opacity: 0.5 },
            _b[".rct-collapse > .rct-icon-expand-close:hover"] = { opacity: 1 },
            _b[".rct-native-display .rct-checkbox"] = { display: "none" },
            _b[".rct-node-clickable"] = { cursor: "pointer" },
            _b[".rct-node-clickable:hover"] = { backgroundcolor: "rgba(51, 51, 204, 0.1)" },
            _b[".rct-node-clickable:focus"] = {
                outline: "0",
                backgroundcolor: "rgba(51, 51, 204, 0.2)"
            },
            _b[".rct-node-icon"] = { color: "#33c" },
            _b[".rct-title"] = { padding: "0 5px" },
            _b)
    });
};
exports.default = globalBaseTheme;
//# sourceMappingURL=global.js.map